




































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Loading from '@/app/components/Common/Loading.vue'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import SelectFieldSearch from '@/app/components/MachineRent/SelectFieldSearch.vue'
import SelectFieldHeader from '@/app/components/MachineRent/SelectFieldHeader.vue'
import Pagination from '@/app/components/Common/Pagination.vue'

@Component({
  components: {
    Loading,
    SelectFieldSearch,
    SelectFieldHeader,
    Pagination
  }
})
export default class FieldSelectModal extends Vue {
  private showLoading: boolean = false
  private notDataMessage: boolean = false
  private isRequesting: boolean = false
  private selectId: number|null = null
  private selectingFieldData: {[key: string]: string|number}|null = null
  private currentPage: number = 1

  @Prop() private selectedFieldId!: number
  @Prop() private data!: any
  @Prop() private totalCount!: any

  private get changeData (): any {
    return this.data
  }

  private get changeSelect (): any {
    return this.selectedFieldId
  }

  @Watch('changeSelect')
  getSelectField (val: any) {
    this.selectId = this.selectedFieldId
    this.selectingFieldData = null
    for (let i in val) {
      this.selectingFieldData = {
        field_id: val[i].field_id,
        field_name: val[i].field_name,
        group_name: val[i].group_name
      }
    }
  }

  @Watch('changeData')
  getData (val: any) {
    this.showLoading = false
    this.isRequesting = false
    if (this.totalCount === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }
    this.data = val
  }

  private doSelect (data: any) {
    this.selectId = data.field_id
    this.selectingFieldData = {
      field_id: data.field_id,
      field_name: data.field_name,
      group_name: data.group_name
    }
  }

  private doDecision () {
    this.$store.commit('machineRentState/setFieldSearchText', '')
    this.changeList()
    this.$emit('select-field', this.selectingFieldData)
  }

  private doCancel () {
    this.selectId = this.selectedFieldId
    this.$store.commit('machineRentState/setFieldSearchText', '')
    this.changeList()
    this.$emit('close-modal')
  }

  private dofieldSort (data: string) {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    let sort = false
    if (data === this.$store.state.machineRentState.fieldOrderName) {
      if (this.$store.state.machineRentState.fieldSortAsc === true) {
        sort = false
      } else {
        sort = true
      }
    } else {
      sort = true
    }

    this.$store.commit('machineRentState/setFieldCurrentPage', 1)
    this.currentPage = this.$store.state.machineRentState.fieldCurrentPage
    this.$store.commit('machineRentState/setFieldOrderName', data)
    this.$store.commit('machineRentState/setFieldSortAsc', sort)
    this.$emit('change-data')
  }

  private changeList () {
    this.isRequesting = true
    this.showLoading = true
    /* 1ページ目に戻る */
    const pagination: any = this.$refs.pagination
    pagination.resetCurrentPage()
    this.scrollTop()

    this.$store.commit('machineRentState/setFieldCurrentPage', 1)
    this.currentPage = this.$store.state.machineRentState.fieldCurrentPage
    this.$store.commit('machineRentState/setFieldOrderName', 'field_name')
    this.$store.commit('machineRentState/setFieldSortAsc', true)
    this.$emit('change-data')
  }

  destroyed () {
    this.$store.commit('machineRentState/setFieldSearchText', '')
    this.$store.commit('machineRentState/setFieldCurrentPage', 1)
    this.$store.commit('machineRentState/setFieldOrderName', 'field_name')
    this.$store.commit('machineRentState/setFieldSortAsc', true)
  }

  private scrollTop () : any {
    const masterFieldArea: any = document.getElementById('listContainer')!
    masterFieldArea.scrollTop = 0
  }

  private onPageChange (page: number) {
    if (!this.isRequesting) {
      this.showLoading = true
      this.scrollTop()
      this.$store.commit('machineRentState/setFieldCurrentPage', page)
      this.currentPage = this.$store.state.machineRentState.fieldCurrentPage
      this.$emit('change-data')
    }
  }
}
